import { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../assets/icons/close.svg?react';
import EyeIcon from '../../../assets/icons/eye.svg?react';
import EyeOffIcon from '../../../assets/icons/eye-off.svg?react';

const AppendUserSideModal = ({ 
  onClose, 
  onSave 
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleUserAppend = async () => {
    if (!email.trim()) {
      alert('이메일을 입력해주세요.');
      return;
    }

    if (!password.trim()) {
      alert('비밀번호를 입력해주세요.');
      return;
    }

    // 이메일 형식 검증
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      alert('올바른 이메일 형식을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSave({
        email: email.trim(),
        password: password.trim()
      });
      setEmail('');
      setPassword('');
      onClose();
    } catch (error) {
      console.error('사용자 추가 실패:', error);
      alert('사용자 추가에 실패했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>사용자 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>  
              <td>
                <label htmlFor="new_email" className='w-20 mr-10 text-b2-700 required'>이메일</label>
              </td>
              <td>
                <input 
                  value={email} 
                  type="email" 
                  id="new_email" 
                  name="new_email"
                  className='w-full input-primary' 
                  placeholder='이메일을 입력해주세요.' 
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  autoFocus
                  autoComplete="off"
                  data-form-type="other"
                />
              </td>
            </tr>
            <tr>  
              <td>
                <label htmlFor="new_password" className='w-20 mr-10 text-b2-700 required'>비밀번호</label>
              </td>
              <td>
                <div className="relative">
                  <input 
                    value={password}
                    type={showPassword ? "text" : "password"}
                    id="new_password" 
                    name="new_password"
                    className='w-full input-primary' 
                    placeholder='비밀번호를 입력해주세요.' 
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isSubmitting}
                    autoComplete="new-password"
                    data-form-type="other"
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={isSubmitting}
                    title={showPassword ? '비밀번호 숨기기' : '비밀번호 보기'}
                  >
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
              </td>
            </tr>
          </table>
          <div className='flex w-full mt-20'>
            <button 
              className='btn big-btn btn-primary flex-1' 
              onClick={handleUserAppend}
              disabled={isSubmitting || !email.trim() || !password.trim()}
            >
              {isSubmitting ? '추가 중...' : '추가'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AppendUserSideModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AppendUserSideModal;
